<div class="input-group file" :class="'input-group-' + inputSize">
    <input type="text" class="form-control" :id="id" :placeholder="placeholder" :value="value" readonly>
    <label class="input-group-append">
        <span class="input-group-text"><i class="mdi mdi-attach-file mdi-lg"></i></span>
        <input ref="upload" type="file">
    </label>
</div>